import React, { Component } from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import domain from '../domain'
import axios from 'axios'
import { MDBInput } from "mdbreact";
import { FadeLoader } from "react-spinners";
/**
 *  Home Page Popup Modal
 */

import colors from "../colors";
import ReactHTMLParser from "react-html-parser";
import  moment  from "moment";
class DownloadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableDownload: false,
      purpose: null,
      organization: null,
      check: false,
      agency: null,
      stateinfo: null,
      disabled: false,
      country:null,
      loading:false,
      enableothers:false,
    }
  }
  save = async() => {
    const url = `${domain.DBServer}/save-user-download-data`
    const data = {
      theme: 'ET',
      product: 'EB',
      subproduct:null,
      user: this.props.user,
     
      purpose: this.state.purpose,
      
 
    }
    axios.request({
      method: 'post',
      url: url,
      data: data,
    }).then((result) => {
      if (result) {
        console.log(result.data)
        if (result.data) {
          console.log(result.data)
         let requestid=result.data.requestid
         if(requestid!==null)
         {
          this.handleDownloadLink()
         }
        }
      }
    })
  }
  handleDownloadLink = () => {
    // console.log(this.props.etselectedproduct)
    // console.log(this.props.etmn_selectedFile)
    // console.log(this.props.etfn_selectedFile)
    const method = 'POST';
    this.setState({
      loading:true
    })
    const url = `${domain.Fileserver}/download_multiple`
    
//     Actual Evapotranspiration

// Actual Evapotranspiration fortnightly

// Actual Evapotranspiration monthly
// NHP_ISRO_AET_EB_FN1_201901.tif           
// NHP_ISRO_AET_EB_FN2_201901.tif          
// NHP_ISRO_AET_EB_MN_201901.tif
// NHP_ISRO_AET_EB_DY_20201009.tif
// console.log(this.props.etselectedproduct)
// console.log(this.props.etmn_selectedFile)
// console.log(this.props.etfn_selectedFile)
    axios
      .request({
        url,
        method,
        data: {
          theme: 'ET',
          product: (this.props.etselectedproduct==='Actual Evapotranspiration') ? 'EB' : (this.props.etselectedproduct==='Actual Evapotranspiration monthly') ?'EBMN' : (this.props.etselectedproduct==='Actual Evapotranspiration fortnightly' ) ? 'EBFN': (this.props.etselectedproduct==='Actual Evapotranspiration 750') ? 'EB750' :
    (this.props.etselectedproduct==='Actual Evapotranspiration monthly 750') ? 'EBMN750' : (this.props.etselectedproduct==='Actual Evapotranspiration fortnightly 750') ? 'EBFN750' : null,
          d1: this.props.d1 || null,
          d2: this.props.d2 || null,
          user: this.props.user,


          date_data: (this.props.etselectedproduct==='Actual Evapotranspiration') ? null : (this.props.etselectedproduct==='Actual Evapotranspiration monthly') ? this.props.etmn_selectedFile : (this.props.etselectedproduct==='Actual Evapotranspiration fortnightly' ) ? this.props.etfn_selectedFile : 
          (this.props.etselectedproduct==='Actual Evapotranspiration 750') ? null : (this.props.etselectedproduct==='Actual Evapotranspiration monthly 750') ? this.props.etmn_selectedFile :(this.props.etselectedproduct==='Actual Evapotranspiration fortnightly 750' ) ? this.props.etfn_selectedFile : null
        },
        responseType: 'blob', //important
      })
      .then((result) => {
        if (result) {
          console.log("result actual evapotrans ",result,result.data,this.props.etmn_selectedFile)

          const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement('a');
          link.href = downloadUrl;
          if(this.props.etselectedproduct==='Actual Evapotranspiration')
          {
          link.setAttribute('download', `NHP_NRSC_ET_EB_${this.props.d1}_${this.props.d2}.zip`);

          }else if(this.props.etselectedproduct==='Actual Evapotranspiration monthly')
          {
            link.setAttribute('download', `NHP_NRSC_ET_EB_${this.props.etmn_selectedFile}.zip`);

          }else if (this.props.etselectedproduct==='Actual Evapotranspiration fortnightly')
          {
            link.setAttribute('download', `NHP_NRSC_ET_EB_${this.props.etfn_selectedFile}.zip`);
          }



          else if(this.props.etselectedproduct==='Actual Evapotranspiration 750')
          {
          link.setAttribute('download', `AET_SNPP_N_EB_DY_${this.props.d1}_${this.props.d2}.zip`);

          }else if(this.props.etselectedproduct==='Actual Evapotranspiration monthly 750')
          {
            link.setAttribute('download', `AET_SNPP_N_EB_${this.props.etmn_selectedFile}.zip`);

          }else {
            link.setAttribute('download', `AET_SNPP_N_EB_${this.props.etfn_selectedFile}.zip`);
          }

          document.body.appendChild(link);
          link.click();
         link.remove();
          this.props.toggle()
          this.setState({
            loading:false
          })
        }
      });
  };



  onSubmit =  (e) => {
    e.preventDefault();

    if (this.state.purpose !== null ) {
        this.save()

     
    }




  }
  handleCheck = (e) => {
    this.setState({
      check: e.target.value,
      disabled: true,

    })
  }
  changeCountry=(e)=>{
    this.setState({
      country:e.target.value
    })
  }
  changeAgency = (e) => {
    this.setState({
      agency: e.target.value
    })
  }
  changeState = (e) => {
    this.setState({
      stateinfo: e.target.value
    })
  }
  changeOrg = (e) => {
    this.setState({
      organization: e.target.value
    })
  }
  changePurpose = (e) => {
    console.log(e.target.value)
    e.preventDefault()
    this.setState({
      purpose: e.target.value
    })
  }
  changePurpose_multiple=(e)=>{
    if(e.target.value!=='1')
    {
      let value = Array.from(e.target.selectedOptions, option => option.value);
      this.setState({ purpose: value,enableothers:false });

    }
    else{
      this.setState({
        enableothers:true,
        purpose:null
      })
    }
  }
  render() {
    console.log(this.state.enableothers)
    var currentdate=new Date()
    return (
      <MDBContainer >
        {/* <MDBBtn color="primary" onClick={this.toggle(14)}>MDBModal</MDBBtn> */}
        <MDBModal
          isOpen={this.props.modal}
          toggle={this.props.toggle}
          centered
          backdrop={false}
          size="lg"
       
        >
          <MDBModalHeader
            className="text-center"
            titleClass="w-100 font-weight-bold"
            toggle={this.toggle}
            style={{ background: "#3f51b5", color: "white" }}
            toggle={this.props.toggle}
          >
            {this.props.title}
          </MDBModalHeader>
          <MDBModalBody
            style={{
              textAlign: "justify",
              // height: window.innerHeight > 1000 ? "00px" : "300px",

              overflowY: "scroll",
            }}
          >
            <form onSubmit={this.onSubmit} >
          

            
            <div class="form-group row">
                <label for="inputpurpose" class="col-sm-3 col-form-label">Purpose
                <span style={{ color: "red" }}> &nbsp;
                    *(<i>Use Ctrl + left click or mouse dragging for multiple selections</i>)
                  </span></label>
                <div className ="col-sm-8">
               
                    <select
                    multiple="true"
                    className="custom-select"
                    name="hd"
                    id="hd" onChange={this.changePurpose_multiple} required>
                      <option value='Crop water requirement estimation'>Crop water requirement estimation</option>
                      <option value='Irrigation schedulin'>Irrigation scheduling</option>
                      <option value='Water productivity estimation '>Water productivity estimation </option>
                      <option value='Crop yield estimation '>  Crop yield estimation </option>
                      <option value='Climate change studies '>  Climate change studies</option>
                      <option value='Water availability assessment '>   Water availability assessment</option>
                      <option value="1">Others (please specify)</option>
                    </select>

                  
                 
                  <br/>   <br/>
                  {
                    this.state.enableothers  ? <input type="text" onChange={this.changePurpose} value={this.state.purpose} required /> : null
                  }
                  {/* <textarea className="form-control" id="inputpurpose" rows="5" value={this.state.purpose}
                    pattern="[a-zA-Z 0-9]+" minlength="25" maxlength="1000" onChange={this.changePurpose} required ></textarea> */}
                </div>
               
              </div>
              <div class="form-group row col-sm-12 justify-content-center">
              <div className="custom-control custom-checkbox pl-3">
                <input
                  className="custom-control-input"
                  type="checkbox"
                  value={this.state.check}
                  disabled={this.state.disabled}
                  id="invalidCheck"
                  required
                  onChange={this.handleCheck}
                />
                <label className="custom-control-label" htmlFor="invalidCheck">
                I hereby agree to cite the usage of this product in the reports/publications appropriately.

              </label>
               
              </div>
              </div>
              <div class="form-group row justify-content-center">
              <div class="col-sm-12">
                <p>Citation:</p>
<p style={{textAlign:"justify"}}>NRSC, 2021, Actual Evapotranspiration, Geospatial hydro products developed by National Remote Sensing Centre under National Hydrology Project,&nbsp;
<a href={`${domain.bhuvannhpurl}`}>{domain.bhuvannhpurl}</a>, Last accessed:&nbsp;{moment(new Date()).format("DD-MMM-YYYY")}</p>
                </div>
              </div>
              <div class="form-group row d-flex justify-content-center" >
              {/* <div class="col-sm-4" >
              </div> */}
                
                  <button type="submit" class="btn btn-primary text-capitalize">Download</button>
                
                
                {/* <button type="submit" class="btn btn-primary text-capitalize" onClick={this.props.toggle}>Close</button> */}
            
            
              </div>



              {/* <MDBInput label="Organization" background size="lg" required onChange={this.handleOrganization}/>
            Purpose
           
        <input type="submit"/> */}
            </form>

            {/* {this.state.enableDownload ? 
            <button  class="btn btn-primary text-capitalize"  onClick={this.handleDownloadLink}>
         <a onClick={this.handleDownloadLink}>Download</a></button> :

              null} */}
              {
                this.state.loading?
                <div className="sweet-loading">
                        <FadeLoader
                          sizeUnit={"px"}
                          color={"#123abc"}
                          loading={this.state.loading}
                        />
                      </div>:null
              }
          </MDBModalBody>
          {/* <MDBModalFooter>
            
          </MDBModalFooter> */}
        </MDBModal>
      </MDBContainer>
    );
  }
}

export default DownloadModal;
